/* eslint-disable no-alert */
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { fetchFoodApiByIngredient,
  fetchFoodApiByLetter, fetchFoodApiByName } from '../helpers';
import { Button, Form } from 'react-bootstrap';
import './styles.css';

class SearchBar extends Component {
  constructor() {
    super();
    this.state = {
      array: [],
      input: '',
      radio: '',
      rotaComida: false,
      rotaBebida: false,
      errorMessage: '',
    };
    this.foodAPIngredientes = this.foodAPIngredientes.bind(this);
    this.change = this.change.bind(this);
    this.APIcomidas = this.APIcomidas.bind(this);
    this.APIbebidas = this.APIbebidas.bind(this);
    this.twelveCards = this.twelveCards.bind(this);
  }

  change(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value, errorMessage: '' });
  }

  foodAPIngredientes() {
    const { location } = this.props;
    if (location.pathname === '/comidas') {
      this.APIcomidas();
    }
    if (location.pathname === '/bebidas') {
      this.APIbebidas();
    }
  }

  async APIcomidas() {
    const { radio, input } = this.state;
    const { history } = this.props;
    let meals;
    if (radio === 'ingredientes') {
      meals = await fetchFoodApiByIngredient(input);
    }
    if (radio === 'nome') {
      meals = await fetchFoodApiByName(input);
    }
    if (radio === 'primeiraLetra') {
      if (input.length === 1) {
        meals = await fetchFoodApiByLetter(input);
      } else {
        const msg = 'Sua busca deve conter somente 1 (um) caracter';
        this.setState({ errorMessage: msg });
        alert(msg);
        return;
      }
    }
    if (meals) {
      this.setState({ array: meals, rotaComida: true, rotaBebida: false, errorMessage: '' });
    } else {
      const msg = 'Sinto muito, não encontramos nenhuma receita para esses filtros.';
      this.setState({ errorMessage: msg });
      alert(msg);
      return [];
    }
    if (meals.length === 1) {
      history.push(`/comidas/${meals[0].idMeal}`);
    }
  }

  async APIbebidas() {
    const { radio, input } = this.state;
    const { history } = this.props;
    let endPoint;
    if (radio === 'ingredientes') {
      endPoint = `https://www.thecocktaildb.com/api/json/v1/1/filter.php?i=${input}`;
    }
    if (radio === 'nome') {
      endPoint = `https://www.thecocktaildb.com/api/json/v1/1/search.php?s=${input}`;
    }
    if (radio === 'primeiraLetra') {
      if (input.length > 1) {
        const msg = 'Sua busca deve conter somente 1 (um) caracter';
        this.setState({ errorMessage: msg });
        alert(msg);
        return;
      }
      endPoint = `https://www.thecocktaildb.com/api/json/v1/1/search.php?f=${input}`;
    }
    const { drinks } = await fetch(endPoint)
      .then((response) => response.json());
    if (drinks !== null && drinks.length > 1) {
      this.setState({ array: drinks, rotaComida: false, rotaBebida: true, errorMessage: '' });
    } if (drinks === null) {
      const msg = 'Sinto muito, não encontramos nenhuma receita para esses filtros.';
      this.setState({ errorMessage: msg });
      alert(msg);
      return [];
    }
    if (drinks.length === 1) {
      history.push(`/bebidas/${drinks[0].idDrink}`);
    }
  }

  twelveCards(arr) {
    const newArr = [];
    const indiceMaximoParaRenderizarDozeCards = 11;
    const indiceMinino = 0;
    for (let i = indiceMinino; i <= indiceMaximoParaRenderizarDozeCards; i += 1) {
      if (arr[i] !== undefined) {
        newArr.push(arr[i]);
      }
    }
    return newArr;
  }

  render() {
    const { history } = this.props;
    const { array, rotaComida, rotaBebida, errorMessage } = this.state;
    const newArr = this.twelveCards(array);
    return (
      <div className="search-bar-wrapper">
        <div className="search-bar-card">
          <Form.Control
            type="text"
            data-testid="search-input"
            name="input"
            placeholder="Digite aqui o ingrediente ou nome..."
            className="search-bar-input"
            onChange={ (event) => this.change(event) }
          />
          <div className="search-bar-radios">
            <Form.Check
              type="radio"
              name="radio"
              id="radio-nome"
              value="nome"
              label="Nome"
              data-testid="name-search-radio"
              onChange={ (event) => this.change(event) }
            />
            <Form.Check
              type="radio"
              id="radio-ingrediente"
              data-testid="ingredient-search-radio"
              name="radio"
              value="ingredientes"
              label="Ingrediente"
              onChange={ (event) => this.change(event) }
            />
            <Form.Check
              type="radio"
              name="radio"
              id="radio-primeira-letra"
              value="primeiraLetra"
              label="Primeira Letra"
              data-testid="first-letter-search-radio"
              onChange={ (event) => this.change(event) }
            />
          </div>
          <Button
            className="default-button orange search-bar-btn"
            type="button"
            data-testid="exec-search-btn"
            onClick={ async () => this.foodAPIngredientes() }
          >
            Executar Pesquisa
          </Button>

          {errorMessage && (
            <div className="search-bar-error" role="alert" aria-live="polite">
              ⚠️ {errorMessage}
            </div>
          )}
        </div>

        {(rotaComida || rotaBebida) && newArr.length > 0 && (
          <div className="recipes-grid-custom mt-4">
            {rotaComida && newArr.map((food, index) => (
              <div
                key={ food.idMeal }
                data-testid={ `${index}-recipe-card` }
                className="recipe-card-custom"
              >
                <div className="recipe-card-image-wrapper">
                  <button
                    type="button"
                    className="img-btn-reset"
                    onClick={ () => history.push(`/comidas/${food.idMeal}`) }
                  >
                    <img
                      className="linkImage"
                      src={ food.strMealThumb }
                      data-testid={ `${index}-card-img` }
                      alt={ `Foto de ${food.strMeal}` }
                      loading="lazy"
                    />
                  </button>
                </div>
                <div className="recipe-card-content">
                  <h3
                    data-testid={ `${index}-card-name` }
                    className="recipe-card-title"
                  >
                    {food.strMeal}
                  </h3>
                  <button
                    type="button"
                    className="recipe-card-explore btn-reset-link"
                    onClick={ () => history.push(`/comidas/${food.idMeal}`) }
                  >
                    Ver receita completa &rarr;
                  </button>
                </div>
              </div>
            ))}

            {rotaBebida && newArr.map((drink, index) => (
              <div
                key={ drink.idDrink || index }
                data-testid={ `${index}-recipe-card` }
                className="recipe-card-custom"
              >
                <div className="recipe-card-image-wrapper">
                  <button
                    type="button"
                    className="img-btn-reset"
                    onClick={ () => history.push(`/bebidas/${drink.idDrink}`) }
                  >
                    <img
                      src={ drink.strDrinkThumb }
                      className="linkImage"
                      alt={ `Foto de ${drink.strDrink}` }
                      data-testid={ `${index}-card-img` }
                      loading="lazy"
                    />
                  </button>
                </div>
                <div className="recipe-card-content">
                  <h3
                    data-testid={ `${index}-card-name` }
                    className="recipe-card-title"
                  >
                    {drink.strDrink}
                  </h3>
                  <button
                    type="button"
                    className="recipe-card-explore btn-reset-link"
                    onClick={ () => history.push(`/bebidas/${drink.idDrink}`) }
                  >
                    Ver receita completa &rarr;
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

SearchBar.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

const SearchBarLocation = withRouter(SearchBar);

export default SearchBarLocation;
